import React from 'react'

const Footer = () => {
  return (
    <div className='absolute-center'>made by 💕ANSH</div>
  )
}

export default Footer